import { ReactNode } from 'react';
import { SerializedStyles } from '@emotion/react';
import { CalendarEventType } from '../../types';
import { useCalendarDragState } from '../calendar-drag-state-context';

type Props = {
  eventType: CalendarEventType;
  containerStyle?: SerializedStyles[] | SerializedStyles;
  children: ReactNode;
};

export const EventCardWrapper = ({ eventType, containerStyle, children }: Props) => {
  const {
    isEventDropOverlay,
    eventDropOverlayStyle,
    isEventDragOverlay,
    eventDragOverlayStyle,
    isEventCardOverlay,
    eventCardOverlayStyle,
  } = useCalendarDragState();

  return (
    <div
      data-event-type={eventType}
      css={[
        containerStyle,
        isEventCardOverlay && eventCardOverlayStyle,
        isEventDropOverlay && eventDropOverlayStyle,
        isEventDragOverlay && eventDragOverlayStyle,
      ]}
    >
      {children}
    </div>
  );
};
